import React, { createContext, useState } from "react";

import { Job } from "../../../../../models/job";
import { ItemJob } from "../../../../../models/sales";
import { StorageBox } from "../../../../../models/storage.box";
import { WarehouseMap } from "../../../../../models/warehouse.map";
import { MapCell } from "../../../../../models/warehouse.mapcell";

interface MovementContextProps {
  orderSelected?: Job;
  itemJobSelected?: ItemJob;
  storageBoxSelected?: StorageBox;
  mapSelected?: WarehouseMap;
  mapCellSelected?: MapCell;

  setOrderSelected(orderSelected?: Job): void;
  setItemJobSelected(itemJobSelected?: ItemJob): void;
  setStorageBoxSelected(storageBoxSelected?: StorageBox): void;
  setMapSelected(mapSelected?: WarehouseMap): void;
  setMapCellSelected(mapCellSelected?: MapCell): void;
}

const MovementContext = createContext<MovementContextProps>({} as MovementContextProps);

interface MovementProviderProps {
  children: React.ReactChild;
}

const MovementProvider = ({ children }: MovementProviderProps) => {
  const [orderSelected, setOrderSelected] = useState<Job>();
  const [itemJobSelected, setItemJobSelected] = useState<ItemJob>();
  const [storageBoxSelected, setStorageBoxSelected] = useState<StorageBox>();
  const [mapSelected, setMapSelected] = useState<WarehouseMap>();
  const [mapCellSelected, setMapCellSelected] = useState<MapCell>();

  return (
    <MovementContext.Provider
      value={{
        orderSelected,
        itemJobSelected,
        storageBoxSelected,
        mapSelected,
        mapCellSelected,
        setOrderSelected,
        setItemJobSelected,
        setMapCellSelected,
        setMapSelected,
        setStorageBoxSelected,
      }}
    >
      {children}
    </MovementContext.Provider>
  );
};

export { MovementContext, MovementProvider };
